import { render, staticRenderFns } from "./titleProperty.vue?vue&type=template&id=121a128e"
import script from "./titleProperty.vue?vue&type=script&lang=js"
export * from "./titleProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports